module.exports = __webpack_public_path__ + "img/music-vid.8d133bb6.gif";